<template>
  <span class="sharer-rates-actions">
    <rates-action :view="view" :show-range="showRange" :table-ref="tableRef" :allow-publish="true" />
    <default-tier-template-button />
  </span>
</template>

<script>
import DefaultTierTemplateButton from './DefaultTierTemplateButton'
import RatesAction from '@/components/finance/rates/actions/RatesAction'

export default {
  name: 'sharer-rates-actions',

  // DataTable injects a `size: 'small'` into add-props; we don't use it, so
  // keep it off the root <span> rather than letting it fall through as an attr.
  inheritAttrs: false,

  components: {
    DefaultTierTemplateButton,
    RatesAction
  },

  props: {
    view: {
      type: String,
      default: 'sharer'
    },
    showRange: {
      type: Boolean,
      default: true
    },
    tableRef: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.sharer-rates-actions {
  display: inline-flex;
  align-items: flex-end;
  /* Stacked (the actions el-col is narrow): "+ Sharer" on top, the template
     button below with a generous gap that also drops it near the HR. */
  gap: 20px;
  justify-content: flex-end;
  flex-wrap: wrap;
}
</style>
